import { ProductsOrder } from "common/order/ProductsOrder";
import { useState, useEffect } from "react";
import laptop from "assets/images/laptop.png";
import mos from "assets/images/mos.png";
import headphone from "assets/images/headphone.png";
import hard from "assets/images/hard.png";
import sharzher from "assets/images/sharzher.png";
import { ProductsRepair } from "common/order/ProductsRepair";
import "common/order/orders.scss";
// import ComolatePriceModal from "common/order/ComplatePriceModal";
import ComplatePrieModalAdmin from "common/order/ComplatePriceModalAdmin";
import StatusReportModal from "common/order/StatusReportModal";
import UpdateRepairModal from "common/order/UpdateRepairModal";
import UpdateOrderModal from "common/order/UpdateOrderModal";
import Pagination from "rc-pagination";
import "rc-pagination/assets/index.css";
import Filter from "common/order/Filter";
import Addorders from "common/order/Addorders";
import AddRepairsModal from "common/order/AddrepairsModal";
import AddOrderModal from "common/order/AddOrderModal";

import sendRequest from "hooks/useAxios";
import sendRequest2 from "../hooks/useAxios2";
export default function Orderstor() {
  const [items, setItems] = useState([
    {
      type: "repair",
      addDevice: [],
      TypeOfOrders: 0,
      typeAccount: "admin",
      NameUser: "علی احمدی",
      ReceivedDate: "1400/06/06",
      Price: 134000,
      Discount: 34000,
      PriceSingleProduct: 1000000,
      DeviceName: "ایسوس",
      DeviceModel: "zembook",
      TrackingCode: "12456",
      status: 1,
      phone: "09112341010",
      description:
        "جمشید انصاری، معاون رئیس‌جمهور و رئیس سازمان اداری و استخدامی کشور در جریان بازدید از بیست‌وچهارمین دوره‌ی الکامپ در آخرین روز این نمایشگاه، مدعی شد",

      completePayment: {
        complatePrice: 6444000,
        discount: 0,
        Amountpaid: 6444000,
        debtAmount: 2444000
      },
      information: [
        {
          img: laptop,
          title: "لپتاپ 17/3اینچی",
          price: "10,000,000تومان",
          desc: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت"
        },
        {
          img: hard,
          title: "هارد اکسترنال",
          price: "10,000,000تومان",
          desc: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت"
        },
        {
          img: headphone,
          title: "هدفون بی سیم بیتس",
          desc: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت",

          price: "10,000,000تومان",
          desc: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت"
        },
        {
          img: sharzher,
          title: "شارژر لپ تاپ 15 ولت و5 آمپر",
          price: "10,000,000تومان"
        },
        {
          img: hard,
          title: "هارد اکسترنال",
          price: "10,000,000تومان",
          desc: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت"
        },
        {
          img: headphone,
          title: "هدفون بی سیم بیتس",
          desc: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت",

          price: "10,000,000تومان",
          desc: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت"
        },
        {
          img: sharzher,
          title: "شارژر لپ تاپ 15 ولت و5 آمپر",
          price: "10,000,000تومان"
        }
      ],
      statusReport: [
        {
          type: false,
          date: "1400/4/10",
          MessageText: "لپتاپ شما به هارد اکسترنال 1 ترا احتیاج دارد",
          img: hard
        },
        {
          type: true,
          date: "1400/4/11",
          MessageText: "لپتاپ شما نیاز به تعویض ویندوز دارد",
          img: laptop
        }
      ],
      chat: [
        {
          senderMessage: "admin",
          message:
            "Lorem ipsum dolor sit amet, consectetur \n" + " adipiscing elit,",
          time: "9:02AM"
        },
        {
          senderMessage: "user",
          message: "Lorem ipsum dolor ",
          time: "9:02AM"
        },
        {
          senderMessage: "admin",
          message: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, ",
          time: "9:02AM"
        },
        {
          senderMessage: "user",
          message: "Lorem ipsum dolor",
          time: "9:02AM"
        }
      ],
      debtAmount: "",
      paidAmount: 10000000
    },
    {
      type: "repair",
      addDevice: [],

      TypeOfOrders: 0,
      typeAccount: "admin",
      NameUser: "علی احمدی",
      ReceivedDate: "1400/06/06",
      Price: 134000,
      Discount: 34000,
      PriceSingleProduct: 100000,
      DeviceName: "ایسوس",
      DeviceModel: "zembook",
      TrackingCode: "12456",
      status: 2,
      phone: "09112341010",

      description:
        "جمشید انصاری، معاون رئیس‌جمهور و رئیس سازمان اداری و استخدامی کشور در جریان بازدید از بیست‌وچهارمین دوره‌ی الکامپ در آخرین روز این نمایشگاه، مدعی شد",
      completePayment: {
        complatePrice: 6444000,
        discount: 0,
        Amountpaid: 6444000,
        debtAmount: 2444000
      },
      information: [
        {
          img: laptop,
          title: "لپتاپ 17/3اینچی",
          price: "10,000,000تومان",
          desc: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت"
        },
        {
          img: hard,
          title: "هارد اکسترنال",
          price: "10,000,000تومان",
          desc: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت"
        },
        {
          img: headphone,
          title: "هدفون بی سیم بیتس",
          price: "10,000,000تومان",
          desc: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت"
        },
        {
          img: sharzher,
          title: "شارژر لپ تاپ 15 ولت و5 آمپر",
          price: "10,000,000تومان",
          desc: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت"
        },
        {
          img: headphone,
          title: "هدفون بی سیم بیتس",
          price: "10,000,000تومان",
          desc: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت"
        },
        {
          img: sharzher,
          title: "شارژر لپ تاپ 15 ولت و5 آمپر",
          price: "10,000,000تومان",
          desc: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت"
        }
      ],
      statusReport: [
        {
          type: false,
          date: "1400/3/10",
          MessageText: "لپتاپ شما به هارد اکسترنال 1 ترا احتیاج دارد",
          img: hard
        },
        {
          type: true,
          date: "1400/3/11",
          MessageText: "لپتاپ شما نیاز به تعویض ویندوز دارد",
          img: laptop
        }
      ],
      chat: [
        {
          senderMessage: "admin",
          message:
            "Lorem ipsum dolor sit amet, consectetur \n" + " adipiscing elit,",
          time: "9:02AM"
        },
        {
          senderMessage: "user",
          message: "Lorem ipsum dolor ",
          time: "9:02AM"
        },
        {
          senderMessage: "admin",
          message: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, ",
          time: "9:02AM"
        },
        {
          senderMessage: "user",
          message: "Lorem ipsum dolor",
          time: "9:02AM"
        }
      ],
      debtAmount: "",
      paidAmount: 1000000
    },

    {
      type: "order",
      selectedProducts: [],
      link: "https://b2n.ir/w37888",
      TypeOfOrders: 1,
      debtAmount: 20000,
      paidAmount: 25000,
      price: 450000,
      Discount: 34000,
      PriceSingleProduct: 1000000,
      typeAccount: "admin",
      NameUser: "علی احمدی",
      phone: "09112341010",

      submitDate: "1400/01/1",
      paymentDate: "1400/06/8",
      sendDate: "1400/06/8",
      OrderNumber: "13456",
      orderStatus: 0,
      title: "aa",
      address: "هرجایی کوچه اول",
      description:
        "جمشید انصاری، معاون رئیس‌جمهور و رئیس سازمان اداری و استخدامی کشور در جریان بازدید از بیست‌وچهارمین دوره‌ی الکامپ در آخرین روز این نمایشگاه، مدعی ",
      information: [
        { img: laptop, title: "لپتاپ 17/3اینچی", price: "10,000,000تومان" },
        { img: hard, title: "هارد اکسترنال", price: "10,000,000تومان" },
        {
          img: headphone,
          title: "هدفون بی سیم بیتس",
          price: "10,000,000تومان"
        },
        {
          img: sharzher,
          title: "شارژر لپ تاپ 15 ولت و5 آمپر",
          price: "10,000,000تومان"
        }
      ],
      details: "جزیات بیشتر",
      completePayment: {
        complatePrice: 6444000,
        discount: 0,
        Amountpaid: 6444000,
        debtAmount: 2444000
      },
      chat: [
        {
          senderMessage: "admin",
          message:
            "Lorem ipsum dolor sit amet, consectetur \n" + " adipiscing elit,",
          time: "9:02AM"
        },
        {
          senderMessage: "user",
          message: "Lorem ipsum dolor ",
          time: "9:02AM"
        },
        {
          senderMessage: "admin",
          message: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, ",
          time: "9:02AM"
        },
        {
          senderMessage: "user",
          message: "Lorem ipsum dolor",
          time: "9:02AM"
        }
      ]
    },
    {
      type: "repair",
      addDevice: [],

      TypeOfOrders: 1,
      debtAmount: 20000,
      paidAmount: 10000,
      typeAccount: "admin",
      NameUser: "علی احمدی",
      id: 0,
      title: "aa",

      ReceivedDate: "1400/06/06",
      Price: 134000,
      Discount: 34000,
      PriceSingleProduct: 100000,
      DeviceName: "ایسوس",
      DeviceModel: "zembook",
      TrackingCode: "12456",
      status: 2,
      phone: "09112341010",
      Statusreport: "صورت وضعیت",
      description:
        "جمشید انصاری، معاون رئیس‌جمهور و رئیس سازمان اداری و استخدامی کشور در جریان بازدید از بیست‌وچهارمین دوره‌ی الکامپ در آخرین روز این نمایشگاه، مدعی شده",
      completePayment: {
        complatePrice: 6444000,
        discount: 0,
        Amountpaid: 6444000,
        debtAmount: 2444000
      },
      information: [
        {
          img: laptop,
          title: "لپتاپ 17/3اینچی",
          price: "10,000,000تومان",
          desc: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت"
        },
        {
          img: hard,
          title: "هارد اکسترنال",
          price: "10,000,000تومان",
          desc: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت"
        },
        {
          img: headphone,
          title: "هدفون بی سیم بیتس",
          price: "10,000,000تومان",
          desc: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت"
        },
        {
          img: sharzher,
          title: "شارژر لپ تاپ 15 ولت و5 آمپر",
          price: "10,000,000تومان",
          desc: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت"
        },
        {
          img: laptop,
          title: "لپتاپ 17/3اینچی",
          price: "10,000,000تومان",
          desc: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت"
        },
        {
          img: hard,
          title: "هارد اکسترنال",
          price: "10,000,000تومان",
          desc: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت"
        }
      ],
      statusReport: [
        {
          type: false,
          date: "1400/6/10",
          MessageText: "لپتاپ شما به هارد اکسترنال 1 ترا احتیاج دارد",
          img: hard
        },
        {
          type: true,
          date: "1400/6/11",
          MessageText: "لپتاپ شما نیاز به تعویض ویندوز دارد",
          img: laptop
        }
      ],
      chat: [
        {
          senderMessage: "admin",
          message:
            "Lorem ipsum dolor sit amet, consectetur \n" + " adipiscing elit,",
          time: "9:02AM"
        },
        {
          senderMessage: "user",
          message: "Lorem ipsum dolor ",
          time: "9:02AM"
        },
        {
          senderMessage: "admin",
          message: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, ",
          time: "9:02AM"
        },
        {
          senderMessage: "user",
          message: "Lorem ipsum dolor",
          time: "9:02AM"
        }
      ]
    },
    {
      type: "repair",
      addDevice: [],

      TypeOfOrders: 0,
      debtAmount: 20000,
      paidAmount: 10000,
      typeAccount: "admin",
      NameUser: "علی احمدی",
      id: 1,
      ReceivedDate: "1400/06/06",
      Price: 134000,
      Discount: 34000,
      PriceSingleProduct: 100000,
      DeviceName: "ایسوس",
      DeviceModel: "zembook",
      TrackingCode: "12456",
      status: 3,
      phone: "09112348888",
      Statusreport: "صورت وضعیت",
      description:
        "جمشید انصاری، معاون رئیس‌جمهور و رئیس سازمان اداری و استخدامی کشور در جریان بازدید از بیست‌وچهارمین دوره‌ی الکامپ در آخرین روز این نمایشگاه، مدعی شده",
      completePayment: {
        complatePrice: 6444000,
        discount: 0,
        Amountpaid: 6444000,
        debtAmount: 2444000
      },
      information: [
        {
          img: laptop,
          title: "لپتاپ 17/3اینچی",
          price: "10,000,000تومان",
          desc: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت"
        },
        {
          img: hard,
          title: "هارد اکسترنال",
          price: "10,000,000تومان",
          desc: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت"
        },
        {
          img: headphone,
          title: "هدفون بی سیم بیتس",
          desc: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت",

          price: "10,000,000تومان",
          desc: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت"
        },
        {
          img: sharzher,
          title: "شارژر لپ تاپ 15 ولت و5 آمپر",
          price: "10,000,000تومان"
        },
        {
          img: laptop,
          title: "لپتاپ 17/3اینچی",
          price: "10,000,000تومان",
          desc: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت"
        },
        {
          img: hard,
          title: "هارد اکسترنال",
          price: "10,000,000تومان",
          desc: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت"
        }
      ],
      statusReport: [
        {
          type: false,
          date: "1400/5/10",
          MessageText: "...",
          img: hard
        },
        {
          type: true,
          date: "1400/5/11",
          MessageText: "..",
          img: laptop
        }
      ],
      chat: [
        {
          senderMessage: "admin",
          message:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua",
          time: "9:02AM"
        },
        {
          senderMessage: "user",
          message: "Lorem ipsum dolor",
          time: "9:02AM"
        },
        {
          senderMessage: "admin",
          message:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua",
          time: "9:02AM"
        },
        {
          senderMessage: "user",
          message: "Lorem ipsum dolor",
          time: "9:02AM"
        },
        {
          senderMessage: "admin",
          message:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua",
          time: "9:02AM"
        }
      ]
    },
    {
      type: "order",
      selectedProducts: [],
      link: "",
      TypeOfOrders: 1,
      debtAmount: 20000,
      paidAmount: 25000,
      price: 450000,
      Discount: 34000,
      PriceSingleProduct: 1000000,
      typeAccount: "admin",
      NameUser: "علی احمدی",
      title: "aa",
      phone: "09112341010",

      submitDate: "1400/01/1",
      paymentDate: "1400/06/8",
      sendDate: "1400/06/8",
      OrderNumber: "13456",
      orderStatus: 1,
      address: "هرجایی کوچه دوم",
      description:
        "جمشید انصاری، معاون رئیس‌جمهور و رئیس سازمان اداری و استخدامی کشور در جریان بازدید از بیست‌وچهارمین دوره‌ی الکامپ در آخرین روز این نمایشگاه، مدعی ",
      information: [
        { img: laptop, title: "لپتاپ 17/3اینچی", price: "10,000,000تومان" },
        { img: hard, title: "هارد اکسترنال", price: "10,000,000تومان" },
        {
          img: headphone,
          title: "هدفون بی سیم بیتس",
          price: "10,000,000تومان"
        },
        {
          img: headphone,
          title: "هدفون بی سیم بیتس",
          price: "10,000,000تومان"
        },
        {
          img: headphone,
          title: "هدفون بی سیم بیتس",
          price: "10,000,000تومان"
        },
        {
          img: headphone,
          title: "هدفون بی سیم بیتس",
          price: "10,000,000تومان"
        },
        {
          img: headphone,
          title: "هدفون بی سیم بیتس",
          price: "10,000,000تومان"
        },
        {
          img: headphone,
          title: "هدفون بی سیم بیتس",
          price: "10,000,000تومان"
        },
        {
          img: headphone,
          title: "هدفون بی سیم بیتس",
          price: "10,000,000تومان"
        },
        {
          img: headphone,
          title: "هدفون بی سیم بیتس",
          price: "10,000,000تومان"
        }
      ],
      details: "جزیات بیشتر",
      completePayment: {
        complatePrice: 6444000,
        discount: 0,
        Amountpaid: 6444000,
        debtAmount: 2444000
      },
      chat: [
        {
          senderMessage: "admin",
          message:
            "Lorem ipsum dolor sit amet, consectetur \n" + " adipiscing elit,",
          time: "9:02AM"
        },
        {
          senderMessage: "user",
          message: "Lorem ipsum dolor ",
          time: "9:02AM"
        },
        {
          senderMessage: "admin",
          message: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, ",
          time: "9:02AM"
        },
        {
          senderMessage: "user",
          message: "Lorem ipsum dolor",
          time: "9:02AM"
        }
      ]
    },
    {
      type: "order",
      selectedProducts: [],
      link: "https://b2n.ir/a34120",

      TypeOfOrders: 0,
      debtAmount: 20000,
      paidAmount: 25000,
      price: 450000,
      Discount: 34000,
      PriceSingleProduct: 1000000,
      title: "aa",
      phone: "09112341010",
      typeAccount: "admin",
      NameUser: "علی احمدی",
      submitDate: "1400/01/01",
      paymentDate: "1400/06/8",
      sendDate: "1400/06/8",
      OrderNumber: "13456",
      orderStatus: 2,
      address: "هرجایی کوچه سوم",
      description:
        "جمشید انصاری، معاون رئیس‌جمهور و رئیس سازمان اداری و استخدامی کشور در جریان بازدید از بیست‌وچهارمین دوره‌ی الکامپ در آخرین روز این نمایشگاه، مدعی ",
      information: [
        { img: laptop, title: "لپتاپ 17/3اینچی", price: "10,000,000تومان" },
        { img: hard, title: "هارد اکسترنال", price: "10,000,000تومان" },
        {
          img: headphone,
          title: "هدفون بی سیم بیتس",
          price: "10,000,000تومان"
        },
        {
          img: mos,
          title: "شارژر لپ تاپ 15 ولت و5 آمپر",
          price: "10,000,000تومان"
        }
      ],
      details: "جزیات بیشتر",

      completePayment: {
        complatePrice: 6444000,
        discount: 0,
        Amountpaid: 6444000,
        debtAmount: 2444000
      },
      chat: [
        {
          senderMessage: "admin",
          message:
            "Lorem ipsum dolor sit amet, consectetur \n" + " adipiscing elit,",
          time: "9:02AM"
        },
        {
          senderMessage: "user",
          message: "Lorem ipsum dolor ",
          time: "9:02AM"
        },
        {
          senderMessage: "admin",
          message: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, ",
          time: "9:02AM"
        },
        {
          senderMessage: "user",
          message: "Lorem ipsum dolor",
          time: "9:02AM"
        }
      ]
    }
  ]);
  const [updater, setUpdater] = useState(false);

  // state info from api
  const [orderLists, setOrderLists] = useState([]);

  const filterOrder = (filterInput, type) => {
    type == "1"
      ? sendRequest2("newfilterorder", filterInput).then(({ data }) => {
          setOrderLists(data.info.reverse());
        })
      : setUpdater(prev => !prev);
  };
  const [selectedItem, setSelectedItem] = useState({});
  const [chatList, setChatList] = useState([]);
  const updateSelectedItem = information => {
    console.log("information", information);
    setSelectedItem(information);
    setChatList(information.chats);
  };
  useEffect(() => {
    sendRequest2("newfilterorder").then(({ data }) => {
      setOrderLists(data.info.reverse());
      setSelectedItem(prev => {
        let temp = data.info.find(value => {
          return value.id == prev?.id;
        });
        if (temp == undefined) {
          return {};
        } else {
          return temp;
        }
      });
    });
  }, [updater]);
  const [currentPage, setCurrentPage] = useState(1);
  return (
    <div className="order-container">
      <Filter
        filterFunction={filterOrder}
        setCurrentPage={setCurrentPage}
      ></Filter>
      <Addorders></Addorders>
      <AddRepairsModal orderUpdater={setUpdater}></AddRepairsModal>
      <AddOrderModal orderUpdater={setUpdater}></AddOrderModal>
      <ComplatePrieModalAdmin
        selectedItem={selectedItem}
      ></ComplatePrieModalAdmin>
      <StatusReportModal
        selectedItem={selectedItem}
        pageType="0"
        setUpdater={setUpdater}
        // chats={selectedItem.chats}
        // chats={chatList}
        // setChats={setChatList}
      ></StatusReportModal>
      <UpdateRepairModal
        selectedItem={selectedItem}
        updateSelectedItem={updateSelectedItem}
        orderUpdater={setUpdater}
      ></UpdateRepairModal>
      <UpdateOrderModal
        selectedItem={selectedItem}
        updateSelectedItem={updateSelectedItem}
        orderUpdater={setUpdater}
      ></UpdateOrderModal>
      {orderLists
        .slice((currentPage - 1) * 5, (currentPage - 1) * 5 + 5)
        .map((value, index) => {
          if (value.type == "0") {
            return (
              <ProductsOrder
                data={value}
                index={index}
                updateSelectedItem={updateSelectedItem}
                pageType="admin"
              ></ProductsOrder>
            );
          } else {
            return (
              <ProductsRepair
                data2={value}
                index={index}
                updateSelectedItem={updateSelectedItem}
                pageType="admin"
              ></ProductsRepair>
            );
          }
        })}
      <div className="d-flex justify-content-center mt-4">
        <div>
          <Pagination
            total={orderLists.length}
            pageSize={5}
            hideOnSinglePage={true}
            current={currentPage}
            onChange={newPage => {
              setCurrentPage(newPage);
            }}
          ></Pagination>
        </div>
      </div>
    </div>
  );
}
